import { render, staticRenderFns } from "./EditUserGroups.vue?vue&type=template&id=26e29c67&"
import script from "./EditUserGroups.vue?vue&type=script&lang=js&"
export * from "./EditUserGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports